import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { CreateModifierContext, ICreateModifierContext } from '../../../createModifierState/createModifierContext';
import React, { useContext } from 'react';
import { InputFields } from './components/InputFields';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '95:46',
		optimalResolutions: {
			a: '380*184px',
			b: '760*368px',
		},
	},
	vertical: {
		ratio: '44:19',
		optimalResolutions: {
			a: '528*228px',
			b: '1056*456px',
		},
	},
};

export const CreationForm: React.FC = () => {
	const { setFileId, fileId } = useContext<ICreateModifierContext>(CreateModifierContext);

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				deletePhotoHandler={deletePhotoHandler}
				setFileId={setFileId}
				horizontalAspectRatio={380 / 184}
				verticalAspectRatio={528 / 228}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};
